export default __webpack_public_path__ + "static/yield-manager-boost-agility-gradient-6b9cd7b8d908c2dd3ae564c7de23ba68.svg";